import { subscribeToNewsletter } from '../../newsletter/services/NewsletterService';

// This function handles pending newsletter actions when the user interacts with a premium feature.
export const handlePendingAction = async (
  isUserPremium: boolean, // Whether the user is a premium user or not.
  openSnackbar: (message: string) => void, // Function to display a message to the user via a snackbar (notification).
  setSubscribedNewsletters: React.Dispatch<React.SetStateAction<string[]>>, // Function to update the list of subscribed newsletters.
  setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>, // Function to open a dialog, usually for premium subscription prompts.
  translations: any // Object containing translation strings for various user messages.
) => {
  // Retrieve any pending newsletter action from localStorage.
  const pendingAction = localStorage.getItem('pendingPremiumNewsletterAction');

  if (pendingAction) {
    // Check if the user is a premium subscriber.
    if (isUserPremium) {
      try {
        // Attempt to subscribe the user to the newsletter.
        const response = await subscribeToNewsletter(pendingAction);

        if (response.status === 'ok') {
          openSnackbar(translations?.snackBarMessages?.subscribedToNewsletter || 'You subscribed to this newsletter');

          // Update the list of subscribed newsletters to include the newly subscribed one.
          setSubscribedNewsletters((prev) => [...prev, pendingAction]);
        }
      } catch (error) {
        // If there's an error during the subscription, log it and notify the user.
        console.error('Error when subscribing to the newsletter:', error);
        openSnackbar(
          translations?.snackBarMessages?.somethingWentWrong || "There's been a mistake, please try again later."
        );
      }
    } else {
      // If the user is not a premium subscriber, open a dialog
      setIsDialogOpen(true);
    }

    // Remove the pending action from localStorage once it has been handled.
    localStorage.removeItem('pendingPremiumNewsletterAction');
  }
};
